import { useAuth } from "../contexts/AuthContext";

// Whether fuel loads should recalculate automatically after edits. Defaults to
// true, including for users whose /api/me predates the preference.
export const useAutoRecalculate = (): boolean => {
  const { user } = useAuth();
  return user?.auto_recalculate !== false;
};
